import { forwardRef } from 'react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import Fuse from 'fuse.js';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, styles, Text } from '@frontend/design-system';
import { CallHistoryItem } from '../../providers/softphone-history-provider';
import { highlightMatches } from './autocomplete-utils';

type Props = {
  item: CallHistoryItem;
  matches?: readonly Fuse.FuseResultMatch[] | undefined;
  onClick: () => void;
  trackingId?: string;
  active?: boolean;
};
export const AutocompleteCallHistoryPerson = forwardRef<HTMLLIElement, Props>(
  ({ item, matches, onClick, trackingId, active }: Props, ref) => {
    const { t } = useTranslation('softphone');
    if (!item.person) {
      return null;
    }
    const name = `${item.person.FirstName} ${item.person.LastName}`;
    return (
      <li
        ref={ref}
        data-trackingid={trackingId}
        className='history'
        key={item.timestamp}
        css={{
          background: active ? theme.colors.neutral70 : 'transparent',
        }}
      >
        <PopoverMenuItem
          css={{
            background: 'transparent',
          }}
          className='list-item'
          onClick={onClick}
          active={active}
        >
          <Text
            color='white'
            css={[
              styles.multilineTruncate(2),
              css`
                max-width: 100%;
              `,
            ]}
          >
            {matches === undefined ? name : highlightMatches(name, (matches?.[0]?.indices ?? []) as [number, number][])}
          </Text>
          <Text
            size='small'
            css={css`
              color: ${theme.colors.neutral30};
            `}
          >
            {t('Last Called: {{time}}', { time: dayjs(item.timestamp).format('MMM D, h:mma') })}
          </Text>
        </PopoverMenuItem>
      </li>
    );
  }
);

AutocompleteCallHistoryPerson.displayName = 'AutocompleteCallHistoryPerson';
